// src/lib/people.ts — the people directory used to render note authors and the
// @mention picker, ported from the prototype bp-data.jsx (USERS). Representative
// until Phase 6 (Users & Access) wires the live dbo.users roster; notifications
// for @mentions are simulated as a toast for now (DATA-MODEL "Notifications").
//
// Note identity stored server-side keys off the real session: a note's `by` and
// each `ack` entry is the author's email (session.upn). Seeded notes carry the
// prototype directory ids below. resolvePerson() bridges both.

import type { Me } from "../auth";

export interface Person { id: string; name: string; dept: string; title: string; email: string; }

export const PEOPLE: Record<string, Person> = {
  sarah: { id: "sarah", name: "Sarah Kenyon", dept: "operating", title: "Operations Manager",       email: "sarah.kenyon@nymr.co.uk" },
  dave:  { id: "dave",  name: "Dave Pringle",  dept: "mpd",       title: "Shed Foreman, MPD",        email: "dave.pringle@nymr.co.uk" },
  brian: { id: "brian", name: "Brian Walker",  dept: "pway",      title: "P-Way Supervisor",         email: "brian.walker@nymr.co.uk" },
  geoff: { id: "geoff", name: "Geoff Pullan",  dept: "st",        title: "S&T Engineer",             email: "geoff.pullan@nymr.co.uk" },
  mark:  { id: "mark",  name: "Mark Allitt",   dept: "cw",        title: "C&W Supervisor",           email: "mark.allitt@nymr.co.uk" },
  helen: { id: "helen", name: "Helen Carr",    dept: "pullman",   title: "Dining & Catering Lead",   email: "helen.carr@nymr.co.uk" },
  tom:   { id: "tom",   name: "Tom Hield",     dept: "lineside",  title: "Lineside Volunteer",       email: "tom.hield@nymr.co.uk" },
  jan:   { id: "jan",   name: "Jan Howes",     dept: "catering",  title: "Tea Rooms Supervisor",     email: "jan.howes@nymr.co.uk" },
  ron:   { id: "ron",   name: "Ron Teasdale",  dept: "operating", title: "Duty Signalman, Grosmont", email: "ron.teasdale@nymr.co.uk" },
  paula: { id: "paula", name: "Paula Sefton",  dept: "events",    title: "Events Coordinator",       email: "paula.sefton@nymr.co.uk" },
};

/** Resolve a note's author / ack key to a person for display. */
export function resolvePerson(key: string, me: Me): Person {
  if (PEOPLE[key]) return PEOPLE[key];
  if (key.toLowerCase() === me.email.toLowerCase()) {
    return { id: me.email, name: me.name, dept: me.dept, title: me.title ?? "", email: me.email };
  }
  return { id: key, name: key, dept: "operating", title: "", email: key };
}

/** People available to @mention (the directory, excluding the signed-in user). */
export function mentionCandidates(me: Me): Person[] {
  return Object.values(PEOPLE).filter((p) => p.email.toLowerCase() !== me.email.toLowerCase());
}
